export default {
	title: "Asistente ORI",
	subtitle: "Resuelve tus dudas sobre el sistema",
	openLabel: "Abrir asistente",
	closeLabel: "Cerrar",
	expandLabel: "Expandir",
	collapseLabel: "Contraer",
	clearLabel: "Borrar conversación",
	placeholder: "Escribe tu duda...",
	send: "Enviar",
	thinking: "Escribiendo...",
	emptyTitle: "¿Cómo puedo ayudarte?",
	emptyHint: "Pregunta sobre registros, rituales, finanzas y más.",
	disclaimer:
		"Las respuestas generadas por IA pueden contener errores. Verifica la información importante.",
	clearConfirm: "¿Borrar toda la conversación?",
	errorGeneric: "No pude responder ahora. Inténtalo de nuevo.",
	errorUnavailable: "Asistente no disponible en este momento.",
	suggestions: {
		s1: "¿Cómo registro una persona?",
		s2: "¿Cómo hago la llamada de fichas?",
		s3: "¿Dónde veo el cierre financiero?",
	},
	guidedMode: {
		question: "¿Cómo prefieres configurar el terreiro?\n\n**Automático**: yo preparo cada registro y tú solo lo confirmas en la tarjeta.\n**Manual**: te guío por la pantalla y tú lo haces, aprendiendo el camino.",
		automatic: "Automático",
		manual: "Manual",
	},
	quickReplies: {
		label: "Opciones de respuesta",
	},
	actions: {
		confirm: "Confirmar",
		edit: "Editar",
		cancel: "Cancelar",
		created: "¡Creado con éxito!",
		createError: "No pude crear. Inténtalo de nuevo.",
		createErrorWithReason: "No pude crearlo: {reason}",
		checkOnScreen: "Este registro puede que ya se haya creado. Revisa la pantalla antes de pedirlo de nuevo.",
		noPermission: "No tienes permiso para esto.",
		continue: "Continuar",
		continueMsg: "Listo, creé ese. Vamos al siguiente.",
	},
};
